import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'zikatagov-switch',
  template: `
    <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        [id]="id"
        [checked]="checked"
        [disabled]="disabled"
        (change)="onToggle($event)"
      >
      <label class="form-check-label" [for]="id">
        {{ label }}
      </label>
    </div>
  `,
   standalone: true,
  styles: [`
    .form-check-input {
      cursor: pointer;
    }
    .form-check-input:checked {
      background-color: #4a0072;
      border-color: #4a0072;
    }
    .form-check-input:focus {
      border-color: #4a0072;
      box-shadow: 0 0 0 0.25rem rgba(74, 0, 114, 0.25);
    }
  `]
})
export class ZikataSwitchComponent {
  @Input() id = '';
  @Input() label = '';
  @Input() checked = false;
  @Input() disabled = false;

  @Output() checkedChange = new EventEmitter<boolean>();

  onToggle(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.checkedChange.emit(isChecked);
  }
}